/**
 * @generated SignedSource<<a29b09783fe9aa5dbaca0efd5e16bec0>>
 * @relayHash d476d150df3ed5244b896179176af3cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea8945a70156b0e6ef8bae1986c4a0b7fa509f9e2517d04cd635ce03b865cbd3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { modal_EnforceStorageLimitQuery } from './modal_EnforceStorageLimitQuery.graphql';

const node: PreloadableConcreteRequest<modal_EnforceStorageLimitQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ea8945a70156b0e6ef8bae1986c4a0b7fa509f9e2517d04cd635ce03b865cbd3",
    "metadata": {},
    "name": "modal_EnforceStorageLimitQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
